import { useEffect, useState } from "react";

const LOGIN_STATE_KEY = "loginInProgress";

export function setLoginInProgress(status) {
	localStorage.setItem(LOGIN_STATE_KEY, status ? "true" : "false");
}

export function useLoginProgress() {
	const [loginProgress, setLoginProgress] = useState(false);
	useEffect(() => {
		function login(event) {
			if (event.key === LOGIN_STATE_KEY) {
				setLoginProgress(event.newValue === "true");
			}
		}
		window.addEventListener("storage", login);
		return () => {
			window.removeEventListener("storage", login);
		};
	}, []);

	return {
		inProgress: loginProgress,
	};
}

